<script setup lang="ts">
import type { FloorListVO, otherEvaluateList } from '~/server/newhouse/interface'

import OtherFloor from '~/components/Evaluating/otherFloor.vue'

const props = defineProps({
  dataList: {
    type: Array as PropType<FloorListVO[]>,
    default: () => [],
  },
  title: {
    type: String,
    default: '推荐楼盘',
  },
  showLikeList: {
    type: Boolean,
    default: true,
  },
  evaluateList: {
    type: Array as PropType<otherEvaluateList[]>,
    default: () => [],
  },
})

/**
 * 只要五个数据
 */
const localDataList = ref<FloorListVO[]>([...(props?.dataList || [])].splice(0, 5))
</script>

<template>
  <!--  卡片 -->
  <CardRevise v-show="showLikeList && dataList?.length > 0" :title="title">
    <div v-show="showLikeList" class="data-box">
      <LikeItem v-for="(item, index) in localDataList" :key="index" v-bind="item" />
    </div>
  </CardRevise>
  <CardRevise v-show="!showLikeList && evaluateList?.length > 0" :title="title">
    <div class="data-box-two">
      <OtherFloor v-for="(item, index) in evaluateList" :key="index" v-bind="item" />
    </div>
  </CardRevise>
</template>

<style scoped lang="scss">
.data-box {
  width: 100%;
  padding: 30px;
  display: flex;
  justify-content: flex-start;

  a + a {
    margin-left: 22px;
  }
}

.data-box-two {
  display: flex;
  justify-content: flex-start;
  //flex-wrap: wrap;
  grid-column-gap: 38px;
  //grid-row-gap: 20px;
  width: 100%;
  padding: 30px;
}
</style>
